<template>
  <div class="dashboard">
    <!-- Filter Section -->
    <v-layout align-center style="gap: 10px">
      <v-flex xs3 class="font-32 font-w-700">Dashboard</v-flex>
      <v-flex xs3>
        <v-layout
          align-center
          v-if="(activeTab != 'KPI' || $route.query.tab != 'KPI') && (activeTab != 'building' && $route.query.tab != 'building')"
        >
          <v-flex xs3 class="d-flex justify-end"> แผนงาน </v-flex>
          <v-flex xs9 class="pl-2">
            <v-select
              solo
              flat
              height="36"
              menu-props="offsetY"
              hide-details
              placeholder="แผนงาน"
              :items="plans"
              item-text="plan_name_en"
              item-value="id"
              v-model="filter.plan_id"
              :class="filter.plan_id ? 'selected_active' : ''"
              color="#F9BB43"
              clearable
              @click:clear="filter.plan_id = null"
              style="border-radius: 25px"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs3 class="pl-3">
        <v-layout align-center>
          <v-flex xs3 class="d-flex justify-end"> ภูมิภาค </v-flex>
          <v-flex class="pl-2">
            <v-select
              solo
              flat
              height="36"
              menu-props="offsetY"
              hide-details
              placeholder="ภูมิภาค"
              item-text="name"
              item-value="id"
              :items="region"
              v-model="filter.region_id"
              :class="filter.region_id ? 'selected_active' : ''"
              color="#F9BB43"
              clearable
              @click:clear="filter.region_id = null"
              style="border-radius: 25px"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs3 class="pl-3">
        <v-layout align-center>
          <v-flex xs3 class="d-flex justify-end"> ปี งปม. </v-flex>
          <v-flex class="pl-2">
            <v-select
              solo
              flat
              height="36"
              menu-props="offsetY"
              hide-details
              :items="year"
              item-text="name"
              item-value="name"
              placeholder="ปี งปม."
              v-model="filter.year"
              :class="filter.year ? 'selected_active' : ''"
              color="#F9BB43"
              clearable
              @click:clear="filter.year = null"
              style="border-radius: 25px"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout mt-5 align-center justify-space-between style="gap: 30px">
      <!-- <v-spacer /> -->
      <!-- -------------------------------------------------------------------------------------------------- -->
      <v-flex xs4>
        <v-flex>
          <v-btn dark depressed fab
                 color="#F9BB43"
                 background-color="linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%)"
                 width="36"
                 height="36"
                 @click="reDashBoard()"
          >
            <Icon class="font-20" icon="bx:refresh" />
          </v-btn>
        </v-flex>
      </v-flex>
      <v-flex xs4>
        <v-layout class="tab_select">
          <v-flex
            class="tab_select_item"
            :class="
              activeTab == 'KPI' || $route.query.tab == 'KPI'
                ? 'active_tab_select'
                : ''
            "
            xs4
            @click="onSelectTab('KPI')"
          >
            KPI/KRI
          </v-flex>
          <v-flex
            class="tab_select_item"
            :class="
              activeTab == 'budget' || $route.query.tab == 'budget'
                ? 'active_tab_select'
                : ''
            "
            xs4
            @click="onSelectTab('budget')"
          >
            งบประมาณ
          </v-flex>
          <v-flex
            class="tab_select_item"
            :class="
              activeTab == 'progress' || $route.query.tab == 'progress'
                ? 'active_tab_select'
                : ''
            "
            xs4
            @click="onSelectTab('progress')"
          >
            ผลติดตาม
          </v-flex>
          <v-flex
            class="tab_select_item"
            :class="
              activeTab == 'building' || $route.query.tab == 'building'
                ? 'active_tab_select'
                : ''
            "
            xs4
            @click="onSelectTab('building')"
          >
            บริหารจัดการอาคาร
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs4>
        <v-layout align-center justify-end style="gap: 20px">
          <v-flex shrink>
            <v-btn
              min-width="134"
              height="35"
              color="#F9BB43"
              style="border-radius: 25px"
              depressed
              dark
              :loading="loadingScreenshot"
              @click="screenshot()"
            >
              <Icon class="font-18" icon="iconoir:screenshot" />
              <span class="ml-2 font-14 font-w-700">Screenshot</span>
            </v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn
              min-width="134"
              height="35"
              color="#5CB844"
              style="border-radius: 25px"
              depressed
              dark
              @click="exportToExcel = true"
            >
              <Icon class="font-18" icon="file-icons:microsoft-excel" />
              <span class="ml-2 font-14 font-w-700">Export Excel</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
      
    </v-layout>

    <KPI
      id="printKPI"
      v-if="activeTab == 'KPI' || $route.query.tab == 'KPI'"
      :filter="filter"
      :exportExcel="exportToExcel"
      :region="region"
      @clearExportExcel="exportToExcel = $event"
    />

    <Budget
      id="printBudget"
      v-if="activeTab == 'budget' || $route.query.tab == 'budget'"
      :filter="filter"
      :exportExcel="exportToExcel"
      @clearExportExcel="exportToExcel = $event"
    />

    <FollowUp
      id="printFollowUp"
      v-if="activeTab == 'progress' || $route.query.tab == 'progress'"
      :filter="filter"
      :exportExcel="exportToExcel"
      :region="region"
      @clearExportExcel="exportToExcel = $event"
    />
    <Building
      id="printBuilding"
      v-if="activeTab == 'building' || $route.query.tab == 'building'"
      :filter="filter"
      :exportExcel="exportToExcel"
      :region="region"
      @clearExportExcel="exportToExcel = $event"
    />
  </div>
</template>

<script>
import * as htmlToImage from "html-to-image";

import { Icon } from "@iconify/vue2";
import KPI from "./KPI.vue";
import Building from "./Building.vue";
import Budget from "./Budget.vue";
import FollowUp from "./FollowUp.vue";

export default {
  name: "Dashboard",
  components: { KPI, Icon, Budget, FollowUp,Building },
  data() {
    return {
      activeTab: 1,
      filter: {
        plan_id: "",
        region_id: "",
        year: "",
      },
      plans: [],
      region: [],
      year: [],
      loadingScreenshot: false,
      exportToExcel: false,
    };
  },
  async created() {
    await Promise.all([
      this.onSelectTab(this.$route.query.tab || "KPI"),
      this.getRegion(),
      this.getPlans(),
    ]);

    // get year list now to 5 year
    let year = new Date().getFullYear();
    for (let i = 0; i < 10; i++) {
      this.year.push({ name: year - i + 543 });
    }
  },
  methods: {
    async getRegion() {
      let res = await this.$apiFire("Dashboard/region");
      if (res) {
        this.region = res;
      }
    },
    async getPlans() {
      let res = await this.$apiFire("Dashboard/plans");
      if (res) {
        this.plans = res;
      }
    },
    onSelectTab(tab) {
      // clear filter
      this.filter = {
        plan_id: "",
        region_id: "",
        year: "",
      };
      this.activeTab = tab;
      this.$router.push({ query: { tab: tab } });
    },

    async reDashBoard(){
      let res
      res = await this.$apiFire('Dashboard/refresh')
      if(res)
        this.onSelectTab(this.$route.query.tab || "KPI")
    },
    async screenshot() {
      this.loadingScreenshot = true;
      let id = "",
        filename = "";
      if (this.activeTab == "KPI" || this.$route.query.tab == "KPI") {
        id = "printKPI";
        filename = "KPIs.jpeg";
      } else if (
        this.activeTab == "budget" ||
        this.$route.query.tab == "budget"
      ) {
        id = "printBudget";
        filename = "Budget.jpeg";
      } else if (
        this.activeTab == "progress" ||
        this.$route.query.tab == "progress"
      ) {
        id = "printFollowUp";
        filename = "FollowUp.jpeg";
      }
      var node = await document.getElementById(id);

      if (!node) return;

      const dataUrl = await htmlToImage.toPng(node);

      // download image
      var link = document.createElement("a");
      link.download = filename;
      link.href = dataUrl;
      link.click();

      this.loadingScreenshot = false;
    },
  },
};
</script>

<style lang="scss">
.dashboard {
  .tab_select {
    background: #ffffff;
    box-shadow: inset 0px 0px 10px rgba(0, 0, 0, 0.25);
    border-radius: 22px;
    padding: 8px 8px;
    width: fit-content;
    min-width: fit-content;
    max-width: 100%;
    gap: 10px;
    .tab_select_item {
      text-align: center;
      font-weight: 500;
      font-size: 12px;
      border-radius: 15px;
      min-width: max-content;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      padding: 0 10px;
    }
    .tab_select_item:hover {
      cursor: pointer;
      background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
      color: #ffffff;
    }
    .active_tab_select {
      text-align: center;
      background: linear-gradient(21.01deg, #f15a29 6.18%, #fbb040 84.83%);
      color: #ffffff;
    }
  }
  .selected_active {
    border: 1px solid #f7941d;
    .mdi-menu-down::before {
      color: #f7941d !important;
    }
  }
}
</style>
